// =============================================================================
// FILE PATH : src/modules/pms/task_template/components/TaskTemplateTable.js
// MODULE    : PMS → Task Template
// PURPOSE   : Table view for Task Templates
// =============================================================================

import React from "react";


const tableStyle = {
  width: "100%",
  borderCollapse: "collapse",
  background: "#fff",
  borderRadius: "8px",
  overflow: "hidden",
  boxShadow: "0 2px 6px rgba(0,0,0,0.08)"
};

const thStyle = {
  textAlign: "left",
  padding: "12px",
  background: "#f5f5f5",
  fontSize: "14px",
  fontWeight: "600",
  color: "#444",
  borderBottom: "1px solid #ddd"
};

const tdStyle = {
  padding: "12px",
  borderBottom: "1px solid #eee",
  fontSize: "14px",
  color: "#333"
};

const actionBtn = {
  marginRight: "8px",
  cursor: "pointer",
  border: "none",
  background: "transparent",
  fontSize: "14px"
};

const statusBadge = (active) => ({
  padding: "4px 10px",
  borderRadius: "12px",
  fontSize: "12px",
  fontWeight: "500",
  background: active ? "#e6f4ea" : "#fdecea",
  color: active ? "#2e7d32" : "#c62828"
});


const TaskTemplateTable = ({
  templates = [],
  onEdit,
  onDelete
}) => {

  if (!templates.length) {
    return (
      <div style={{ padding: "20px", textAlign: "center", color: "#777" }}>
        No templates found
      </div>
    );
  }

  return (
    <table style={tableStyle}>
      <thead>
        <tr>
          <th style={thStyle}>Template Name</th>
          <th style={thStyle}>Type</th>
          <th style={thStyle}>Equipment</th>
          <th style={thStyle}>Tasks</th>
          <th style={thStyle}>Status</th>
          <th style={thStyle}>Actions</th>
        </tr>
      </thead>

      <tbody>
        {templates.map((t) => (
          <tr key={t.id}>

            {/* TEMPLATE NAME */}
            <td style={tdStyle}>{t.template_name}</td>

            {/* TYPE */}
            <td style={tdStyle}>{t.template_type}</td>

            {/* EQUIPMENT */}
            <td style={tdStyle}>
              {t.template_type === "EQUIPMENT"
                ? t.equipment_name || "-"
                : "-"}
            </td>

            {/* TASK COUNT */}
            <td style={tdStyle}>
              {t.items ? t.items.length : 0}
            </td>

            {/* STATUS */}
            <td style={tdStyle}>
              <span style={statusBadge(t.is_active)}>
                {t.is_active ? "Active" : "Inactive"}
              </span>
            </td>

            {/* ACTIONS */}
            <td style={tdStyle}>
              <button
                style={{ ...actionBtn, color: "#1976d2" }}
                onClick={() => onEdit(t)}
              >
                ✏ Edit
              </button>

              <button
                style={{ ...actionBtn, color: "#d32f2f" }}
                onClick={() => onDelete(t)}
              >
                🗑 Delete
              </button>
            </td>

          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default TaskTemplateTable;